// Названия кодов, которые приходят с сервера машинными: статус занятости, тип документа,
// режим тарифа. Источник — contracts/enums/statuses.yaml, там же и причина: статус это
// справочник, а не цвет заливки ячейки.
//
// Копия названий на клиенте оправдана ровно тем, что эти три набора ЗАМОРОЖЕНЫ схемой базы
// (Literal в server/app/serializers/employees.py). Справочники, которые ведёт администратор
// (типы оформления, юрлица, объекты), сюда не попадают: они приходят с сервера.

import type { DocType, EmployeeStatus, RateMode } from '@/shared/api/endpoints/people';

export const STATUS_TITLES: Readonly<Record<EmployeeStatus, string>> = {
  on_shift: 'На вахте',
  between_shifts: 'Межвахтовый отдых',
  reserve: 'Резерв',
  leave: 'Отпуск',
  sick: 'Больничный',
  fired: 'Уволен',
};

/** Цвет метки статуса. Цвет ДУБЛИРУЕТ слово, а не заменяет его: слово читается всегда. */
export const STATUS_COLORS: Readonly<
  Record<EmployeeStatus, 'green' | 'blue' | 'gray' | 'orange' | 'yellow' | 'red'>
> = {
  on_shift: 'green',
  between_shifts: 'blue',
  reserve: 'gray',
  leave: 'orange',
  sick: 'yellow',
  fired: 'red',
};

export function statusTitle(code: string): string {
  return STATUS_TITLES[code as EmployeeStatus] ?? code;
}

export const DOC_TYPE_TITLES: Readonly<Record<DocType, string>> = {
  passport: 'Паспорт',
  snils: 'СНИЛС',
  inn: 'ИНН',
  guard_license: 'Удостоверение охранника',
  medical_check: 'Медосмотр',
};

export function docTypeTitle(code: string): string {
  return DOC_TYPE_TITLES[code as DocType] ?? code;
}

export const RATE_MODE_TITLES: Readonly<Record<RateMode, string>> = {
  by_period: 'От суммы за период',
  direct: 'Прямая ставка',
  by_target: 'От целевой суммы',
};

export function rateModeTitle(code: string): string {
  return RATE_MODE_TITLES[code as RateMode] ?? code;
}

/** Разряды охранника из тз: четвёртый, пятый и шестой. Другого в законе нет. */
export const GUARD_CATEGORIES = ['4', '5', '6'] as const;

export const PERSON_FORMS = ['человек', 'человека', 'человек'] as const;

/**
 * Те же слова после «у», «не хватает», «больше чем»: «у 1 человека», «у 2 человек», «у 5 человек».
 * Для счёта набор другой («1 человек», «2 человека»), и после «у» он дал бы «у 1 человек» и
 * «у 2 человека»: оба неверно.
 */
export const PERSON_FORMS_GENITIVE = ['человека', 'человек', 'человек'] as const;
